import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class JEService extends BaseService {

  constructor(private http: HttpClient, tokenService: TokenService, private router: Router) {
    super(tokenService);
  }
  // GET SERVICES
  getFarmerPondVerification(userId: any, stage: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerification?UserId=${userId}&Stage=${stage}`, { headers: this.buildHeaders() });
  }

  // getFarmerApplicationForPondVerStage1(userId:any)
  // {
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage1?UserId=${userId}`, { headers: this.buildHeaders() });
  // }

  getFarmerApplicationForPondVerStage1(userId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage1?UserId=${userId}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage1?UserId=${userId}`, { headers: this.buildHeaders() });
    }
  }

  // getFarmerApplicationForPondVerStage2(userId:any)
  // {
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage2?UserId=${userId}`, { headers: this.buildHeaders() });

  // }

  getFarmerApplicationForPondVerStage2(userId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage2?UserId=${userId}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerApplicationForPondVerificationStage2?UserId=${userId}`, { headers: this.buildHeaders() });
    }
  }

  GetFarmerAppForPondVer_SubsidyCalc_Stage3(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetFarmerAppForPondVer_SubsidyCalc_Stage3?UserId=${userId}`, { headers: this.buildHeaders() });

  }

  // getPondVerDataByAppIdStage1(appId:any){
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage1?AppId=${appId}`, { headers: this.buildHeaders() });
  // }

  getPondVerDataByAppIdStage1(appId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage1?AppId=${appId}`, { headers: this.buildHeaders() });
  }
  else{
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage1?AppId=${appId}`, { headers: this.buildHeaders() });
  }
}

  // getPondVerDataByAppIdStage2(appId:any){
  //   return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage2?AppId=${appId}`, { headers: this.buildHeaders() });
  // }

  getPondVerDataByAppIdStage2(appId: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage2?AppId=${appId}`, { headers: this.buildHeaders() });
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerificationDataByAppIdStage2?AppId=${appId}`, { headers: this.buildHeaders() });
    }
   
   
  }

  getPondVerDataByAppId_SubsidyCalc_Stage3(appId: any) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetPondVerDataByAppId_SubsidyCalc_Stage3?AppId=${appId}`, { headers: this.buildHeaders() });
  }
  //POST SERVICES
  vendorPondEstimate(vendorPondEstimate: any) {
    return this.http.post(`${environment.apiUrl}Vendor/UpsertPondEstimate`, vendorPondEstimate, { headers: this.buildHeaders() });
  }

  // pondSurveyStage1(pondSurveyStage1: any){
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  // }

  pondSurveyStage1(pondSurveyStage1: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  }
  else{
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage1`, pondSurveyStage1, { headers: this.buildHeaders() });
  }
}

  // pondSurveyStage2(pondSurveyStage2: any){
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  // }

  pondSurveyStage2(pondSurveyStage2: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  }
  else{
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurveyStage2`, pondSurveyStage2, { headers: this.buildHeaders() });
  }
}

  //POST SERVICES
  PondFalseIntimation(PondFalseIntimation: any) {
    return this.http.post(`${environment.apiUrl}Vendor/InsertPondFalseIntimation`, PondFalseIntimation, { headers: this.buildHeaders() });
  }

  //GET Physical Verification Applications for MI
  getApplicationsForPhysicalVerification(userId, appType) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationsForMIPhysicalVer_SubsidyCalc?UserId=${userId}&AppType=${appType}`, { headers: this.buildHeaders() });
    } else {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationsForPhysicalVerification?UserId=${userId}&AppType=${appType}`, { headers: this.buildHeaders() });
    }
  }

  //GET Application data for physical verification
  getApplicationDataForPhysicalVerification(autoId, userId) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForMIPhysicalVer_SubsidyCalc?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
    } else {
      return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
    }
  }

  getApplicationDataForPhysicalVerification_CalculatedSubsidy(autoId, userId) {
    return this.http.get(`${environment.apiUrl}DashBoard/GetApplicationDataForPhysicalVer?AutoId=${autoId}&UserId=${userId}`, { headers: this.buildHeaders() });
  }


  //POST Application data for physical verification
  insertPhysicalVerification(reqBody: any) {
    if ((this.router.url.split('/')[1] == 'department') || (this.router.url.split('/')[1] == 'admin')) {
      return this.http.post(`${environment.apiUrl}DashBoard/InsertPhysicalMIVerification_SubsidyCalc`, reqBody, { headers: this.buildHeaders() });
    } else {
      return this.http.post(`${environment.apiUrl}DashBoard/InsertPhysicalVerification`, reqBody, { headers: this.buildHeaders() });
    }
  }

  insertPondSurvey_SubsidyCalc_Stage3(reqBody: any) {
    return this.http.post(`${environment.apiUrl}DashBoard/InsertPondSurvey_SubsidyCalc_Stage3`, reqBody, { headers: this.buildHeaders() });
  }

  //Insert Servey Attachments
  insertServayAttachments(reqBody: any) {
    return this.http.post(`${environment.apiUrl}Department/InsertServayAttachments`, reqBody, { headers: this.buildHeaders() });
  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage1(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage1SubsidyToFarmerLot?UserId=${userId}`, { headers: this.buildHeaders() });
  
  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage2(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage2SubsidyToFarmerLot?UserId=${userId}`, { headers: this.buildHeaders() });

  }
  GetSubsidyAppForPondVer_SubsidyCalc_Stage3(userId: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondStage3SubsidyToFarmerLot?UserId=${userId}`, { headers: this.buildHeaders() });

  }

  getMICADA1data(userId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMISurveyCoordinates?UserId=${userId}`, { headers: this.buildHeaders() })
  }

  insertMISurveyCoordinates(reqBody){
    return this.http.post(`${environment.apiUrl}Department/InsertMISurveyCoordinates`, reqBody, { headers: this.buildHeaders() });
  }
}
